const NavIconBtn = ({
  onClick,
  children,
  active,
  danger,
  className: cx,
  ...rest
}) => (
  <button
    onClick={onClick}
    className={[
      "relative flex items-center justify-center w-9 h-9 rounded-lg border transition-all duration-200 cursor-pointer",
      active
        ? "bg-velBlue/15 border-velBlue/30"
        : danger
          ? "bg-transparent border-transparent hover:bg-logoutColor/10 hover:border-logoutColor/25"
          : "bg-transparent border-transparent hover:bg-btnHover hover:border-velBlueSecond/25",
      cx,
    ]
      .filter(Boolean)
      .join(" ")}
    {...rest}
  >
    {children}
  </button>
);

export default NavIconBtn;
